const TriviaDisableButtons = ()=>{
    const buttons = document.querySelectorAll('#buttons-categories-trivia .btn');
    if(buttons.length){
        buttons.forEach((button, indice)=>{
            button.addEventListener('click', ()=>{
                localStorage.setItem('categorie-enable', indice);
            });
        }); 
    
        const button = localStorage.getItem('categorie-enable');
        //Disabled buttons no clicked
        button && buttons.forEach((button)=>{
            button.classList.add('hidden-important');
        });
        //Enable button clicked
        button && buttons[parseInt(button)].classList.remove('hidden-important');
    }
}

export { TriviaDisableButtons }